export enum NotificationTypes {
  Push = 'push',
  InApp = 'in-app',
}

export enum NotificationActions {
  Received = 'received',
  Opened = 'opened',
  Clicked = 'clicked',
}